import React, { useContext } from "react";
import { IntlProvider } from "react-intl";
import { observer } from "mobx-react-lite";

import {getISOLocale} from "../utils/locale.ts";
import {AppStoreContext} from "../store/app-store.ts";

type IntlWrapperProps = {
    children: React.ReactNode;
}

const IntlWrapper = observer(({ children }: IntlWrapperProps) => {
  const { locale, messages } = useContext(AppStoreContext);

  return (
    <IntlProvider messages={messages} locale={getISOLocale(locale)} defaultLocale="en-gb">
      {children}
    </IntlProvider>
  );
});

export default IntlWrapper;
